import React from 'react';
import { func, array, object } from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import { themr } from 'react-css-themr';
import { compose } from 'redux';

import styles from './Breadcrumb.scss';

function Breadcrumb({ t, items, theme }) {
  const renderItem = item => {
    const childNode = !!item.link ? (
      <Link to={item.link}>{item.name}</Link>
    ) : (
      item.name
    );

    return (
      <li className={theme.item} key={item.name}>
        {childNode}
      </li>
    );
  };

  return (
    <ul className={theme.root}>
      <li className={theme.item}>
        <Link to="/">{t('subject.home')}</Link>
      </li>
      {items.map(renderItem)}
    </ul>
  );
}

Breadcrumb.propTypes = {
  t: func.isRequired,
  theme: object.isRequired,
  items: array,
};

Breadcrumb.defaultProps = {
  items: [],
};

export default compose(
  translate(['subject']),
  themr('DefaultBreadcrumbTheme', styles)
)(Breadcrumb);



// WEBPACK FOOTER //
// ./app/components/Breadcrumb/Breadcrumb.jsx